import { Col, Collapse, Typography } from "antd";
import { FC } from "react";

interface SecureTypeInfoesProps{
 data:[]
}

const SecureTypeInfoes:FC<SecureTypeInfoesProps> = ({data}) => {
  const { Panel } = Collapse;
  const { Text } = Typography;
  // const data = [
  //   {
  //     title: "Emlak Satın Alma ve Kiralama İçin Güvenlik İpuçları",
  //     desc: [
  //       "Tanımadığınız kişilere kesinlikle para göndermeyin",
  //       "TC kimlik numarası ve cep telefonu numaraları aracılığıyla yapılması talep edilen para transferlerini gerçekleştirmeyin",
  //       "Alacağınız veya kiralayacağınız konutu görmeden, hiçbir sebeple kapora ve benzeri bir ödeme gerçekleştirmeyin.",
  //       "Konutu görmenizin ardından ön ödeme gerçekleştirmeniz halinde yapmış olduğunuz ödemeyi gösteren banka dekontu veya imzalı bir belgenizin olmasına özen gösterin.",
  //       "Herhangi bir ön ödeme veya kapora ödemesi yapmanız sonucunda mal/ürün teslim alamamanız halinde sari-ilanlar.com’un hiçbir hukuki sorumluluğu bulunmamaktadır.",
  //     ],
  //   },
  //   {
  //     title: "Vasıta Satın Alma ve Kiralama İçin Güvenlik İpuçları",
  //     desc: [
  //       "Satıcıyla yüz yüze görüşmeden kesinlikle para göndermeyin. Aracı görmeden kapora için para gönderilmesi taleplerini kabul etmeyin.",
  //       "Alacağınız veya kiralayacağınız aracı görmeden, hiçbir sebeple kapora ve benzeri bir ödeme gerçekleştirmeyin ve/veya aracı satın almayın.",
  //       "Tanımadığınız kişilere TC kimlik numarası ve cep telefonu numaraları kullanılarak yapılabilen para transferlerini gerçekleştirmeyin.",
  //       "Para ödemesi ile ürün teslimini (araç devir işlemini) aynı anda yapın",
  //     ],
  //   },
  // ];

  return (
    <Col xs={24}>
      <Collapse defaultActiveKey={["0","1"]} className="!rounded-lg">
        {data.map((item:any, index) => (
          <Panel
            key={index.toString()}
            className="!bg-[#f4f4f4]"
            header={
              <Text className="font-semibold text-base">{item.name}</Text>
            }
          >
           <Text>
            {item.content}
           </Text>
          </Panel>
        ))}
      </Collapse>
    </Col>
  );
};

export default SecureTypeInfoes;
